import styled from "styled-components";

export const TourListWrapper = styled.div`
 .slick-dots li button {
    &:before {
      font-size: 12px;
    }
  }
  .slick-dots li.slick-active button {
    &:before {
      color: #f7ec96;
    }
  }
  .slick-track{
    display: flex !important;
  }
  .slick-initialized .slick-slide {
    display: block;
    margin: 0 15px;
  }
  .tour_list_name{
    padding: 0 0 4px 0;
    border-bottom: 1px solid #e9e9e9;
    margin:  0 12px;
    h1{
      font-size: 1.6rem;
      margin: 0;
      padding: 0;
    }
  }
`

export const BtnControl = styled.i`
    position: absolute;
    color: #e19292;
    cursor: pointer;
    font-size: 1.8rem;
    transition: all .3s linear;
    &:hover{
        color: #333;
        font-size: 2.0rem;
    }
`
